import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Utilities as U} from '@shared/utilities/utilities.model';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import { AccessReference } from '@app/shared/models/access-reference.model';
import { Router } from '@angular/router';
import { AppConfigEnvironmentService } from '@app/shared/service/appconfig-environment.service';
import { AppConfigEnvironment } from '@app/shared/models/appconfig-environment.model';

@Component({
	selector: 'amd-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('accessToken') inputHTML: ElementRef;

	text: string = ''
	form: FormGroup;
	formEnum: typeof FormEnum = FormEnum;
	t: TranslateContext = TranslateContext.CORE;
	animationCursor: boolean = false;
	hideButton: boolean = true;
	isTitleUp: boolean = false;
	isTitleVisible: boolean = true;
	env: AppConfigEnvironment;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private appConfigService: AppConfigEnvironmentService,
	) {
		this.text = 'Inserire l\'accessToken';
		this.env = this.appConfigService.Environment;
	}		

	ngOnInit() {

		if (this.env.environment !== 'local') {
			this.router.navigate(['/']);	
			return;
		}

		this.buildForm();
		this.labelComposer();
	}
	
	private buildForm(): void {
		
		this.form = this.formBuilder.group({
			[FormEnum.access_token]: ['', [Validators.required]]
		});
		
		this.form.controls[FormEnum.access_token].valueChanges.subscribe(x => {
			
			if (U.isEmpty(x)) {
				this.isTitleVisible = true;
				this.isTitleUp = true;
				this.hideButton = true;
				return;
			}
			
			this.isTitleVisible = false;
			this.isTitleUp = true;
			this.hideButton = false;
		})
	}

	onSubmit() {
		const val = new AccessReference(JSON.parse(this.form.controls[FormEnum.access_token].value));

		// controllare se il tipo coincide
		if (val && val.isValid()) {
			localStorage.setItem(U.ACCESS_REFERENCE, this.form.controls[FormEnum.access_token].value);
			location.reload();
		}
	}

	private labelComposer(): void {

		// non funziona il reference con ViewChild
		const textElement: HTMLElement = document.getElementById('text-title');
		const DELAY = 50;
		
		for (let i=0; i<this.text.length; i++) {

				setTimeout(function() {
					textElement.innerHTML = this.text.substring(0, i+1);

					// animare il cursore
					if (i === this.text.length-1) {
						this.animationCursor = true;
					}
				}.bind(this), DELAY * i);
		}

		// on focus a fine animazione
		const delayTitleUp: number = (DELAY*this.text.length)+200;
		setTimeout(function() { this.inputHTML.nativeElement.focus() }.bind(this), delayTitleUp);
	}
	
	onFocus(): void {
		if (this.form.controls[FormEnum.access_token].value) {
			this.isTitleVisible = false;
			this.isTitleUp = true;
			return;
		}
		this.isTitleVisible = true;
		this.isTitleUp = true;
	}
	
	onBlur(): void {
		if (this.form.controls[FormEnum.access_token].value) {
			this.isTitleVisible = false;
			this.isTitleUp = true;
			return;
		}
		this.isTitleVisible = true;
		this.isTitleUp = false;
	}
	
	handleFocusOnInput(): void {
		this.inputHTML.nativeElement.focus();
	}
}

enum FormEnum {
	access_token = 'accessToken',
}
